import styled, { css } from 'styled-components';

import Tooltip from '@material-ui/core/Tooltip';

interface ContainerProps {
  isFocused: boolean;
  isField: boolean;
  isErrored: boolean;
}

export const Container = styled.div<ContainerProps>`
  background: #fff !important;
  border-radius: 10px;
  padding: 1rem;
  width: 98%;
  margin: 5px 0;
  border: 2px solid #fff !important;
  color: #ff9800;
  display: flex;
  align-items: center;

  & + div {
    margin-top: 0.5rem;
  }

  ${(props) =>
    props.isErrored &&
    css`
      border-color: #c53030;
    `}

  ${(props) =>
    props.isFocused &&
    css`
      color: #957290;
      border-color: #ff9800;
    `}

  ${(props) =>
    props.isField &&
    css`
      color: #ff9800;
    `}


  textarea {
    flex: 1;
    margin-top: 1.25rem;
    background: transparent;
    border: 0;
    color: #666360 !important;
    resize: none;

    &::placeholder {
      color: #666360;
    }
  }

  svg {
    margin-right: 1rem;
  }
`;

export const Error = styled(Tooltip)`
  height: 1.25rem;
  margin-left: 1rem;
  svg {
    margin: 0;
  }

  span {
    background: #c53030;
    color: #fff;

    &::before {
      border-color: #c53030 transparent;
    }
  }
`;
